import { I_LanguageOption } from '../interfaces/I_LanguageOption';

export const C_LanguageOptions: I_LanguageOption[] = [
  {
    code: 'en',
    name: 'English',
    flag: '/assets/icons/lang/en.svg'
  },
  {
    code: 'fr',
    name: 'France',
    flag: '/assets/icons/lang/fr.svg'
  }
];
